module.exports = __webpack_public_path__ + "img/formsHexagon.96637d95.svg";